import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectWithLayout = createSelector(selectJsonQuery, jsonQuery => getTermValue('with_layout')(jsonQuery));
